import { Dispatch, SetStateAction, useCallback } from 'react';
import { isArray } from 'lodash';

type FilterRecord = { [key: string]: unknown[] | unknown | undefined };

const getNewFilterValue = (
  column: string,
  value: string | number | boolean | null | undefined,
  currentFilters: FilterRecord
) => {
  if (value === undefined || value === null) {
    return [];
  }

  if (isArray(currentFilters[column])) {
    return (currentFilters[column] as unknown[]).filter(
      (item) => item !== value
    );
  }

  return value;
};

/**
 * Default filter behaviours to use alongside RenderFilteredTable
 */
export const useFilterCallbacks = (
  setFilters: Dispatch<SetStateAction<FilterRecord>>
) => {
  const onClearFilter = useCallback(
    (column: string, value?: string | number | boolean | null) => {
      setFilters((currentFilters) => {
        const newFilter = getNewFilterValue(column, value, currentFilters);

        return {
          ...currentFilters,
          [column]: newFilter,
        };
      });
    },
    [setFilters]
  );

  const onClearAllFilters = useCallback(() => {
    setFilters({});
  }, [setFilters]);

  return { onClearFilter, onClearAllFilters };
};
